import RecommendationItem from './RecommendationItem';
import { List } from 'immutable';
import SkillRecommendation from './model';

const reviver = ([key, val]) => {
  if (! val) return [key, val];
  switch (key) {
    case 'skillRecommendationItems':
      return [key, new List(val.map((recommendationItem) =>
          RecommendationItem.create(recommendationItem)))];
    case 'skillId':
      return [key, `${val}`];
    default:
      return [key, val];
  }
};

const create = (data) => new SkillRecommendation(data).mapEntries(reviver);

export default create;



// WEBPACK FOOTER //
// ./data/SkillRecommendation/create.js